import { graphql } from 'react-apollo'
import { localISODate } from '../../helpers/date-helpers'
import getImageFromEntry, {
  MASTER,
  STANDARD,
} from '../../helpers/get-image-from-entry'
import getSponsoredTitle from '../../helpers/get-sponsored-topic'
import { ApplicationError, NotFoundError } from '../../helpers/errors'
import query from './query.graphql'

export { query }

export const mapPropsToOptions = ({ centre, id }) => ({
  variables: {
    id,
    centreId: centre.sys.id,
    startsAt: localISODate(centre.timeZone),
  },
  errorPolicy: 'ignore',
})

export const mapDataToProps = ({
  ownProps: { centre: ownCentre, id, slug },
  data: { centre: respCentre, loading, error },
}) => {
  if (error) {
    return {
      error: new ApplicationError(error),
    }
  } else if (loading) {
    return { loading }
  } else if (!respCentre || !respCentre.story) {
    return {
      error: new NotFoundError(),
    }
  } else if (slug !== respCentre.story.slug) {
    return {
      redirect: `/${ownCentre.slug}/story/${id}/${respCentre.story.slug}`,
    }
  }

  const { story } = respCentre
  const allStores = (story.stores || []).filter(
    store => store.centre.sys.id === ownCentre.sys.id
  )
  const store = allStores.length === 1 ? allStores[0] : null
  return {
    entry: {
      body: story.bodyCopy,
      category: 'Story',
      desktopImage: getImageFromEntry(story, MASTER),
      experiences: story.experiences,
      mobileImage: getImageFromEntry(story, STANDARD),
      retailCategories: story.retailCategories,
      slug: story.slug,
      store,
      stores: allStores.length ? allStores : null,
      topic: getSponsoredTitle(story),
      topics: story.topics,
      title: story.title,
      typename: story.__typename,
      analyticsMetadata: story.analyticsMetadata,
    },
  }
}

const withStoryDetail = graphql(query, {
  options: mapPropsToOptions,
  props: mapDataToProps,
})

export default withStoryDetail
